<!--  -->
<template>
  <div class="section-main__warp visitor-wrap flex-column">
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleTabsClick">
        <el-tab-pane :label="item.label" :name="item.value" v-for="item in tabs" :key="item.value"></el-tab-pane>
      </el-tabs>
    </div>
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      @refresh-change="refreshChange" @selection-change="handleSelectionChange">
      <template slot="search_createTime">
        <div>
          <el-date-picker @change="handleTimeChange" type="datetimerange" v-model="searchTime" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
      </template>
      <!-- <template slot="menuLeft">
        <el-button type="primary" @click="handleAudits" v-if="tabIndex === '0'"
          >批量审批</el-button
        >
      </template> -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip v-if="tabIndex === '1' && scope.row.status == 7" class="item" effect="dark" content="延时"
          placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="icon iconfont-add iconyanshi" @click="delay(scope.row, scope.index)"></el-button>
        </el-tooltip><el-tooltip v-if="tabIndex === '1' && scope.row.status == 2" class="item" effect="dark"
          content="签到" placement="top" popper-class="tooltip-draw">
          <el-button type="text" @click="handleSign(scope.row, 'in')">签到</el-button> </el-tooltip><el-tooltip v-if="(tabIndex === '1' && scope.row.status == 4) ||
        (tabIndex === '1' && scope.row.status == 7)
        " class="item" effect="dark" content="签离" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="el-icon-thumb" @click="handleSign(scope.row, 'out')"></el-button>
        </el-tooltip>
        <el-tooltip v-if="tabIndex === '1'" class="item" effect="dark" content="详情" placement="top"
          popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-Detail" @click="handleView(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip v-if="tabIndex === '0'" class="item" effect="dark" content="审批" placement="top"
          popper-class="tooltip-draw">
          <el-button type="text" icon="el-icon-s-check" @click="handleAudits(scope.row, scope.index)"></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog :title="auditTitle" :visible.sync="auditVisible" @close="handleCloseDialog">
      <div>
        <el-form :model="formData" :rules="formRules" label-position="right" label-width="110px">
          <el-form-item label="访客类型" prop="visitorTypeCode" v-if="!rowData.delayedTime">
            <el-select v-model="formData.visitorTypeCode">
              <el-option v-for="item in visitorTypeList" :key="item.visitorTypeCode" :label="item.visitorTypeName"
                :value="item.visitorTypeCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员通行闸机" prop="turnstileGateThirdDeviceIdList" v-if="!rowData.delayedTime">
            <el-select v-model="formData.turnstileGateThirdDeviceIdList" multiple>
              <el-option v-for="item in personAuthList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="意见描述" prop="remark">
            <el-input
              type="textarea"
              v-model="formData.remark"
              placeholder="请输入理由"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item label="停车场" prop="parkinglotCode" v-if="rowData.isCar == 1 && !rowData.delayedTime">
            <el-select v-model="formData.parkinglotCode">
              <el-option v-for="item in lotList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆通行道闸" prop="vehicleBarrierThirdDeviceIdList"
            v-if="rowData.isCar == 1 && !rowData.delayedTime">
            <el-select v-model="formData.vehicleBarrierThirdDeviceIdList" multiple>
              <el-option v-for="item in carAuthList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="意见描述" prop="remark">
            <el-input type="textarea" v-model="formData.remark" placeholder="请输入理由">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleConfirmAudit('refuse')">拒绝</el-button>

        <el-button @click="handleConfirmAudit('agree')" type="primary" :loading="btnLoading">{{ btnLoading ? "提交中" :
        "同意"
          }}</el-button>
      </div>
    </el-dialog>
    <!-- 签到签离 -->
    <el-dialog :title="signDialogTitle[signType]" :visible.sync="signDialog" width="400px">
      <el-form :model="signForm" label-width="80px" :rules="signFormRules" ref="signForm">
        <el-form-item label="访问时间">{{ signInfo.enterTime }}~{{ signInfo.exitTime }}</el-form-item>
        <el-form-item :label="signType == 'in' ? '签到说明' : '签离说明'" prop="remark">
          <el-input v-model="signForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleSignCancel">取消</el-button>
        <el-button @click="handleSignConfirm" type="primary" :loading="btnLoading">{{
        btnLoading ? "提交中" : "确认"
      }}</el-button>
      </div>
    </el-dialog>
    <add-invitation-component ref="addRef" />
    <detail-dialog ref="detailDialog"></detail-dialog>
    <delay-dialog ref="delayDialog" @delayOk="queryData"></delay-dialog>
  </div>
</template>

<script>
import detailDialog from "../components/details-dialog";
import delayDialog from "../components/delayDialog";
import { Cache } from "$utils";

import utils from "@src/common/utils";
import tableOption from "../const/audit";
import { api } from "../api";
import AddInvitationComponent from "../components/addInvitationComponent";

export default {
  components: { AddInvitationComponent, detailDialog, delayDialog },
  data() {
    return {
      signFormRules: {
        remark: [{ required: true, message: "请输入操作说明", trigger: "change" }],
      },
      btnLoading: false,
      formRules: {
        visitorTypeCode: [
          { required: true, message: "请选择访客类型", trigger: "change" },
        ],
        remark: [
          {
            required: true,
            message: "请输入意见描述",
            trigger: ["blur"],
          },
        ],
        turnstileGateThirdDeviceIdList: [
          {
            required: true,
            message: "请选择人员通行闸机",
            trigger: ["blur"],
          },
        ],
        vehicleBarrierThirdDeviceIdList: [
          {
            required: true,
            message: "请选择车辆通行道闸",
            trigger: ["blur"],
          },
        ],
      },
      formData: {
        visitorTypeCode: "",
        turnstileGateThirdDeviceIdList: [],
        remark: "",
        vehicleBarrierThirdDeviceIdList: [],
        parkinglotCode: "",
        parkinglotName: "",
      },
      tableData: [],
      visitorTypeList: [],
      auditVisible: false,
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      params: {
        // pageNum: 1,
        // pageSize: 10,
      },
      tabIndex: "0",
      // params: {
      //   pageNum: 1,
      //   pageSize: 10,
      // },
      activeName: "0",
      option: tableOption("0"),
      tabs: [
        { label: "待审批", value: "0" },
        { label: "已审批", value: "1" },
      ],
      rowData: {},
      auditTitle: "",
      personAuthList: [],
      carAuthList: [],
      lotList: [],
      signForm: {},
      signDialogTitle: {
        in: "手动签到",
        out: "手动签离",
      },
      signDialog: false,
      signType: "",
      searchTime: [],
      signInfo: {},
    };
  },

  // computed() {},

  mounted() {
    this.queryData();
    this.getVisitorList();
    this.getCarAuthList();
    this.getPeopleAuthList();
    this.queryLotList();
    this.isExistsPersonInfo()
  },

  methods: {
    // 查询当前帐号是否绑定人员库
    isExistsPersonInfo() {
      this.$fetch(api.isExistsPersonInfo, {}).then((res) => {
        if (res.success && res.returnObj) {
          // this.$message.warning("当前登录帐号未关联人员名单库，请先绑定关联人员");
          this.$message({
            showClose: true,
            message: '当前登录帐号未关联人员名单库，请先绑定关联人员',
            type: 'warning',
            duration: 10000
          });
        }
      });
    },
    handleTimeChange(data) {
      console.log(data, ">>>>>data");
      if (data && data.length > 0) {
        this.params.beginTime = data[0];
        this.params.endTime = data[1];
      }
    },
    delay(row) {
      this.$refs.delayDialog.open(row);
      console.log(row, ">>>>>row");
    },
    handleSign(row, type) {
      this.signDialog = true;
      this.signForm.appointmentCode = row.appointmentCode;
      this.signInfo = row;
      this.signType = type;
    },
    handleSignCancel() {
      this.signDialog = false;
      this.signForm = {};
      this.$refs.signForm.resetFields()
    },
    handleSignConfirm() {
      this.$refs.signForm.validate((val) => {
        if (val) {
          this.btnLoading = true;
          let params = {
            appointmentCode: this.signForm.appointmentCode,
            status: this.signType === "in" ? "5" : "7",
            type: "1",
            remark: this.signForm.remark,
          };
          this.$fetch(api.doApprovalVisitor, params).then((res) => {
            setTimeout(() => {
              this.btnLoading = false;
            }, 1000);
            if (!res.success) {
              this.$message.error(res.msgContent);
              return;
            }
            this.$message.success(this.signType === "in" ? "签到成功" : "签离成功");
            this.handleSignCancel();
            this.queryData();
          });
        }
      });
    },
    getVisitorList() {
      this.$fetch(api.getVisitorTypeListApi, {}).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.visitorTypeList = res.returnObj;
      });
    },
    getPeopleAuthList() {
      let deviceName = Cache.get("SYS_TURNSTILE");

      let params = { pageNum: 1, pageSize: 100, deviceName };
      this.$fetch(api.queryPersonDevice, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.personAuthList = res.returnObj.list.map((item) => {
          this.formData.turnstileGateThirdDeviceIdList.push(item.thirdDeviceId);
          return {
            label: item.thirdDeviceName,
            value: item.thirdDeviceId,
          };
        });
      });
    },
    getCarAuthList() {
      let deviceName = Cache.get("SYS_VEHICLE");

      let params = { pageNum: 1, pageSize: 100, deviceName };
      this.$fetch(api.queryVehicleDevice, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.carAuthList = res.returnObj.list.map((item) => {
          this.formData.vehicleBarrierThirdDeviceIdList.push(item.thirdDeviceId);
          return {
            label: item.deviceName,
            value: item.thirdDeviceId,
          };
        });
      });
    },
    handleTabsClick(data) {
      console.log(data, tableOption("0"), ">>>>data");
      this.tabIndex = data.index;
      data.index == "0"
        ? (this.option = tableOption("0"))
        : (this.option = tableOption("1"));
      this.queryData();
      console.log(data, ">>>>>data");
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.refreshChange(this.page);
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.refreshChange(this.page);
    },
    /**
     * 记录信息查询
     */
    queryData() {
      this.tableLoading = true;
      let firstBeginTime = "";
      let lastEndTime = "";

      const param = {
        ...this.params,
        ...this.page,
      };
      let apiUrl = null;
      this.tabIndex === "0"
        ? (apiUrl = api.queryVisitorApprovalPendingList)
        : this.tabIndex === "1"
          ? (apiUrl = api.queryVisitorMyApprovalList)
          : "";

      // this.importExlParams = JSON.parse(JSON.stringify(param))
      this.$fetch(apiUrl, param).then((res) => {
        this.tableLoading = false;
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        if (!res.returnObj) {
          return;
        }
        const _data = res.returnObj;
        this.tableData = _data.list;
        this.page.currentPage = _data.pageNum;
        this.page.pageSize = _data.pageSize;
        this.page.total = _data.total;
        // this.tableData = [{ name: "lsy" }];
      });
    },
    handleCloseDialog() {
      this.auditVisible = false;
      // this.formData = {};
    },
    handleConfirmAudit(type) {
      this.btnLoading = true;
      let params = {
        appointmentCode: this.rowData.appointmentCode,
        status: type == "agree" ? 2 : type === "refuse" ? 3 : "",
        type: "1",
        remark: this.formData.remark,
      };
      if (this.rowData.isCar == 1) {
        params.parkinglotCode = this.formData.parkinglotCode;
        params.parkinglotName = this.formData.parkinglotName;

        params.vehicleBarrierThirdDeviceIdList = this.formData.vehicleBarrierThirdDeviceIdList;
      }
      if (this.rowData.delayedTime) {
        params.delayApproveFlag = "delayApprove";
      } else {
        params.turnstileGateThirdDeviceIdList = this.formData.turnstileGateThirdDeviceIdList; //权限
        params.visitorTypeCode =
          this.rowData.status == 3 && type === "refuse"
            ? []
            : this.formData.visitorTypeCode; //访客类型
      }

      this.$fetch(api.doApprovalVisitor, params).then((res) => {
        if (res.success) {
          this.$message.success("审核成功");
          this.handleCloseDialog();
          this.queryData();
        } else {
          setTimeout(() => {
            this.btnLoading = false;
          }, 2000);
          this.$message.error(res.msgContent);
        }
      });
    },
    queryLotList() {
      let deviceName = Cache.get("SYS_PARKINGLOT");
      let params = {};
      this.$fetch(api.queryDepotLotList, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.lotList = res.returnObj
          .map((item) => {
            return {
              label: item.parkingLot,
              value: item.parkingLotCode,
            };
          })
          .filter((el) => el.label === deviceName);

        this.formData.parkinglotCode = this.lotList[0].value;
        this.formData.parkinglotName = this.lotList[0].label;
        // this.lotList = res.returnObj.list;
      });
    },
    //批量审批
    handleAudits(row) {
      console.log(row, ">>>>>row");
      this.rowData = row;
      this.auditVisible = true;
      this.btnLoading = false;
      this.auditTitle = "审批";
      // this.$confirm("审批", "审批", {
      //   confirmButtonText: "通过",
      //   cancelButtonText: "拒绝",
      //   type: "warning",
      //   distinguishCancelAndClose: true,
      // })
      //   .then((res) => {
      //     this.auditVisible = true;
      //     this.auditTitle = "同意审批";
      //     this.formData.remark = "同意";
      //     this.formData.status = "2";
      //   })
      //   .catch(function (e) {
      //     if (e == "cancel") {
      //       this.auditVisible = true;

      //       this.auditTitle = "拒绝审批";
      //       this.formData.remark = "拒绝";
      //       this.formData.status = "3";

      //     }
      //   });

      // return;
      // let params = {
      //   appointmentCode: row.appointmentCode,
      //   status: this.status,
      //   type: "1",
      //   turnstileGateThirdDeviceIdList: [], //权限
      //   remark: this.inputText,
      //   visitorTypeCode:
      //     this.status == 3
      //       ? []
      //       : this.VisitorTypeList[this.VisitorType].itemValue, //访客类型
      // };
      // this.$fetch(api.doApprovalVisitor, params).then((res) => {
      //   if (res.success) {
      //     this.$message.success("审核成功");
      //     this.queryData();
      //   }
      // });
      // });
    },
    handleView(row) {
      console.log("row", row);
      let param = {
        appointmentCode: row.appointmentCode,
      };
      this.$fetch(api.queryVisitorDetail, param).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.$refs.detailDialog.open(row.appointmentCode);
        // this.$refs.addRef.openPanel("audit", res.returnObj);
      });
    },
    refreshChange(page) {
      this.params = {};
      this.queryData(page);
    },
    // handleSearchChange(param) {
    //   this.params = { ...this.params, ...param };
    //   // tempObj.startTime = this.params.startTime; // let tempObj = {};
    //   // tempObj.endTime = this.params.endTime;
    //   // this.params = Object.assign({}, param);
    //   // this.params.startTime = tempObj.startTime;
    //   // this.params.endTime = tempObj.endTime;
    //   this.queryData();
    // },
    handleSearchChange(param) {
      let tempObj = {};
      tempObj.beginTime = this.params.beginTime;
      tempObj.endTime = this.params.endTime;
      this.params = Object.assign({}, param);
      this.params.beginTime = tempObj.beginTime;
      this.params.endTime = tempObj.endTime;
      this.queryData();
    },
    // 重置列表
    handleSearchReset() {
      this.params = { pageNum: 1, pageSize: 10 };
      this.searchTime = [];
      this.queryData();
    },
    handleSelectionChange(items) {
      console.log(items, ">>>>>irtems");
      // this.checkedAccounts = items.map((item) => {
      //   return item.workGroupCode;
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss">
.el-icon-circle-plus-outline,
.el-icon-thumb {
  font-size: 16px;
}
</style>
